import { render, staticRenderFns } from "./editProblemClassification.vue?vue&type=template&id=2502b377&"
import script from "./editProblemClassification.vue?vue&type=script&lang=js&"
export * from "./editProblemClassification.vue?vue&type=script&lang=js&"
import style0 from "./editProblemClassification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports